import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { KeyRound, Loader2, ShieldAlert } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Expiring demo sign-in link: redeems a hashed, admin-issued token for a short session — no password is ever shown.
export default function DemoAccess() {
  const { token } = useParams();
  const { adoptSession } = useAuth();
  const nav = useNavigate();
  const [state, setState] = useState({ status: "redeeming" });
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return; // StrictMode double-invokes effects; a link use must be consumed exactly once
    fired.current = true;
    api.post("/auth/demo/redeem", { token }).then((r) => {
      adoptSession(r.data.user);
      setState({ status: "ok", user: r.data.user, expires: r.data.session_expires_at });
      setTimeout(() => nav("/dashboard"), 1200);
    }).catch((e) => setState({ status: "error", detail: e.response?.status === 410 ? e.response.data.detail : apiErr(e.response?.data?.detail) || "Demo link invalid, expired or already used" }));
  }, [token, adoptSession, nav]);

  return (
    <div className="min-h-screen bg-[#050A15] text-slate-200 flex items-center justify-center px-4" data-testid="demo-access-page">
      <div className="qs-panel max-w-md w-full p-8 text-center space-y-4">
        <p className="text-[10px] uppercase tracking-widest text-[#00FFFF]">Secure demo access</p>
        {state.status === "redeeming" && <><Loader2 className="h-8 w-8 mx-auto animate-spin text-[#00FFFF]" /><p data-testid="demo-access-status">Checking your invitation…</p></>}
        {state.status === "ok" && <><KeyRound className="h-8 w-8 mx-auto text-[#10B981]" /><h1 className="font-display text-2xl" data-testid="demo-access-status">Welcome, {state.user.name}</h1><p className="text-sm text-slate-400">Signed in as <span className="font-mono text-[#00FFFF]">{state.user.role}</span> · session ends {new Date(state.expires).toLocaleString()}</p></>}
        {state.status === "error" && <><ShieldAlert className="h-8 w-8 mx-auto text-[#EF4444]" /><h1 className="font-display text-xl" data-testid="demo-access-status">{state.detail}</h1><p className="text-sm text-slate-400">Ask the administrator for a fresh link, or <Link to="/login" className="text-[#00FFFF] underline" data-testid="demo-access-login-link">sign in with a password</Link>.</p></>}
      </div>
    </div>
  );
}
